import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setDisplayLoader } from 'redux/app/appSlice';
import {
  setUserId,
  setUserCreatedAt,
  setUserEmail,
  setUserName,
  setUserAvatar,
  resetUser,
} from 'redux/user/userSlice';
import { setBalance } from 'redux/balance/balanceSlice';
import { setPartnerBalance } from 'redux/partners/partnersSlice';
import { setProfileTg } from 'redux/profile/profileSlice';
import { setMonitoringTg } from 'redux/monitoring/monitoringSlice';

import authOperations from 'redux/auth/authOperations';

import userService from 'services/userService';

const getUser = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))

    const response = await userService.getUser()
    const { data: {
      // is_active,
      id,
      created_at,
      email,
      name,
      photo_path,
      telegram_link,
      telegram_mon_link,
      balance,
      balance_partner,
    } } = response

    // if (!is_active) {
    //   dispatch(authOperations.logout())
    //   return
    // }

    dispatch(setUserId(id))
    dispatch(setUserCreatedAt(created_at))
    dispatch(setUserEmail(email))
    dispatch(setUserName(name))
    dispatch(setUserAvatar(photo_path));

    dispatch(setProfileTg(telegram_link || ''))
    dispatch(setMonitoringTg(telegram_mon_link || ''))

    dispatch(setBalance(balance))
    dispatch(setPartnerBalance(balance_partner))
  } catch (e) {
    if (e.response?.status === 401) {
      dispatch(authOperations.reset())
      return
    }

    if (e.response?.status === 429) {
      Notify.failure('Too much requests - try later ...')
      dispatch(resetUser())
      return
    }

    Notify.failure(e.response?.data?.message || 'Request GetUser failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

export default {
  getUser,
}
